export default {
      id: "oc-res-vm-release-usage",
      viewBox: "0 0 1027 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-vm-release",
      toString: function () {
        return this.url;
      }
    }